"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _clsx2 = _interopRequireDefault(require("clsx"));

var _reactI18next = require("react-i18next");

var _constants = require("../../../constants");

var _MotivatorIcons = require("../../MotivatorIcons");

var _common = require("../../../common");

var _BrandTooltip = _interopRequireDefault(require("../../BrandTooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX = 'RadarChart';
var classes = {
  disabled: "".concat(PREFIX, "-disabled")
};
var LABEL_OFFSET_ABOVE_INDEXES = [0, 1, 2, 3, 8, 9, 10];
var CUSTOM_LABEL_OFFSET = 18;
var StyledTypography = (0, _styles.styled)(_material.Typography)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    fontSize: '13px',
    color: theme.palette.font.primary,
    position: 'absolute',
    cursor: 'pointer',
    transitionDuration: '0.3s',
    letterSpacing: '0.1em',
    whiteSpace: 'nowrap'
  }, _defineProperty(_ref2, theme.breakpoints.down('sm'), {
    fontSize: '11px',
    letterSpacing: 0,
    whiteSpace: 'break-spaces',
    textAlign: 'center',
    zIndex: 999
  }), _defineProperty(_ref2, "&.".concat(classes.disabled), {
    opacity: 0.5,
    cursor: 'default',
    pointerEvents: 'none'
  }), _ref2;
});

var getLeftPositionIcon = function getLeftPositionIcon(motivatorIconPosition) {
  var position = ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.left) || 0) - CUSTOM_LABEL_OFFSET;

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 0) {
    return position + 3;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 1) {
    return position - 1;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 2) {
    return position - 6;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 3) {
    return position - 8;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 4) {
    return position - 6;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 5) {
    return position - 1;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 6) {
    return position + 7;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 7) {
    return position + 8;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 8) {
    return position + 15;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 9) {
    return position + 13;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 10) {
    return position + 9;
  }

  return position;
};

var getTopPositionIcon = function getTopPositionIcon(motivatorIconPosition) {
  var position = ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.top) || 0) - CUSTOM_LABEL_OFFSET;

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 0) {
    return position + 14;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 1) {
    return position + 12;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 2) {
    return position + 9;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 3) {
    return position + 2;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 4) {
    return position - 7;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 5) {
    return position - 8;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 6) {
    return position - 10;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 7) {
    return position - 6;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 9) {
    return position + 7;
  }

  if ((motivatorIconPosition === null || motivatorIconPosition === void 0 ? void 0 : motivatorIconPosition.idx) === 10) {
    return position + 12;
  }

  return position;
};

var CustomPointLabels = function CustomPointLabels(_ref3) {
  var motivatorIconPositions = _ref3.motivatorIconPositions,
      handleSetSelected = _ref3.handleSetSelected,
      selected = _ref3.selected,
      handleMixpanelEvent = _ref3.handleMixpanelEvent;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var theme = (0, _styles.useTheme)();
  var matches = (0, _material.useMediaQuery)(theme.breakpoints.down('sm'));

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      noGaps = _useState2[0],
      setNoGaps = _useState2[1];

  (0, _react.useEffect)(function () {
    if (motivatorIconPositions) {
      var withGaps = Object.entries(motivatorIconPositions).filter(function (motivator) {
        return motivator[1].isSelectable === true;
      });

      if (withGaps.length == 0) {
        setNoGaps(true);
      } else {
        setNoGaps(false);
      }
    }
  }, [motivatorIconPositions]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Object.entries(_constants.SCALES_BY_ID).map(function (entry) {
    if (!motivatorIconPositions) return null;
    var scaleId = parseInt(entry[0], 10);
    var scaleName = entry[1].toUpperCase();

    var scale = _constants.SCALES_BY_ID[scaleId].split(' ').map(function (word) {
      return (0, _common.capitalize)(word);
    }).join('');

    var Icon = _MotivatorIcons.ALL_MOTIVATOR_ICONS["".concat(scale, "Filled")];

    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      key: scaleName,
      container: true,
      direction: "column",
      alignItems: "center",
      sx: {
        position: 'absolute',
        left: getLeftPositionIcon(motivatorIconPositions[scaleName]),
        top: getTopPositionIcon(motivatorIconPositions[scaleName]),
        width: 'fit-content'
      }
    }, /*#__PURE__*/_react.default.createElement(StyledTypography, {
      onClick: function onClick() {
        return handleSetSelected({
          scaleId: scaleId,
          idx: motivatorIconPositions[scaleName].idx,
          gap: motivatorIconPositions[scaleName].metadata.gap,
          iconClicked: true
        });
      },
      className: (0, _clsx2.default)(_defineProperty({}, classes.disabled, !motivatorIconPositions[scaleName].isSelectable)),
      sx: {
        fontWeight: 700,
        width: matches ? '80px' : 'auto',
        marginTop: LABEL_OFFSET_ABOVE_INDEXES.includes(motivatorIconPositions[scaleName].idx) ? motivatorIconPositions[scaleName].isSelectable ? matches ? '-28px' : '-50px' : matches ? '-20px' : '-30px' : motivatorIconPositions[scaleName].isSelectable ? matches ? '45px' : '60px' : matches ? '30px' : '40px'
      }
    }, t(_constants.SCALES_BY_ID[scaleId].replace(' ', '_')).toUpperCase()), !motivatorIconPositions[scaleName].isSelectable ? /*#__PURE__*/_react.default.createElement(_BrandTooltip.default, {
      title: t('not_a_gap'),
      onMouseEnter: function onMouseEnter() {
        return handleMixpanelEvent('gap_hovers_no_gap_motivator_icons');
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(Icon, {
      height: "30px",
      style: {
        cursor: 'pointer',
        transitionDuration: '0.3s',
        transformOrigin: 'center center',
        transform: "".concat((selected === null || selected === void 0 ? void 0 : selected.scaleId) === scaleId ? matches ? 'scale(1.67)' : 'scale(2.5)' : matches ? 'scale(0.8)' : 'none'),
        opacity: !noGaps ? 0.2 : 1,
        pointerEvents: 'none'
      }
    }))) : /*#__PURE__*/_react.default.createElement(Icon, {
      height: "30px",
      onClick: function onClick() {
        return handleSetSelected({
          scaleId: scaleId,
          idx: motivatorIconPositions[scaleName].idx,
          gap: motivatorIconPositions[scaleName].metadata.gap,
          iconClicked: true
        });
      },
      style: {
        cursor: 'pointer',
        transitionDuration: '0.3s',
        transformOrigin: 'center center',
        transform: "".concat((selected === null || selected === void 0 ? void 0 : selected.scaleId) === scaleId ? matches ? 'scale(1.67)' : 'scale(2.5)' : matches ? 'scale(1.3)' : 'scale(1.67)'),
        opacity: 1,
        pointerEvents: 'default'
      }
    }));
  }));
};

var _default = CustomPointLabels;
exports.default = _default;